// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.WaybillNumber[data-v-8eddfb92] {\n  color: #00A551;\n  cursor: pointer;\n  padding: 0;\n}\n.omit[data-v-8eddfb92] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n", ""]);
// Exports
module.exports = exports;
